import axios from "axios";

export const apiPath = axios.create({
  baseURL: process.env.REACT_APP_URL_API_PRODUCTION,
});
